import { CountryCodeEnum } from '../../app/enums/countryCodeEnum';
import { MembershipTypeEnum } from '../../app/enums/MembershipTypeEnum';
import { PaymentDto } from '../../app/models/payment/paymentDto';
import { Product } from '../../app/models/staticData/product';
import PaymentProductJsonDto from '../../app/models/affiliateOnboarding/paymentProductJsonDto';
import { PaymentRedirectProps } from '../../app/models/membership/paymentRedirectProps';
import { AppPathEnum } from '../../app/enums/appPathEnum';

export function getPaymentProducts(paymentDetails: PaymentDto | null, products: Product[] | null | undefined) {
  const rows: { year: string; amount: number | null }[] = [];
  paymentDetails?.paymentProducts.forEach(paymentProduct => {
    if (paymentProduct.jsonValues !== null) {
      const values = JSON.parse(paymentProduct.jsonValues) as PaymentProductJsonDto;
      if (values.Year) rows.push({
        year: values.Year + ' ' + products?.find(product => product.id === paymentProduct.productId)?.name,
        amount: paymentProduct.cost
      });
    }
  });
  return rows;
}

export function shouldPreparePcsOnlyPayment(reenrol: boolean, canPayMembership: boolean | null | undefined, finalisePaymentCheck: boolean | null | undefined): boolean {
  return canPayMembership === false && (finalisePaymentCheck === true || reenrol === false);
}

export function getPaymentRedirectProps(paymentId: string, location: { href: string; search: string; pathname: string }, redirectUri: string): PaymentRedirectProps {
  const cancelUrl = new URL(location.href);
  cancelUrl.searchParams.set('expectedStep', '4');
  return {
    cancelUrl: cancelUrl.toString(),
    paymentId,
    successUrl: redirectUri + AppPathEnum.PCS_ENROLMENT_PAYMENT_SUCCEED + '/' + location.search + '$$retry-url=' + location.pathname.replace(/\/$/, '') + '$$expectedStep=4'
  };
}

export function validatePaymentRedirect(redirect: string): void {
  const url = new URL(redirect);
  if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid redirect');
}

export function isPcsDiscountApplicable(membershipCode: string | null | undefined, countryCode: string | null | undefined): boolean {
  return (membershipCode === MembershipTypeEnum.FELLOW || membershipCode === MembershipTypeEnum.MEMBER)
    && countryCode === CountryCodeEnum.IRELAND;
}

// Each stage uses the identifier returned by this payment attempt.
export async function preparePcsPayment(isCombined: boolean, operations: {
  enrolBasket: (combined: boolean) => Promise<string>;
  getPaymentId: (basketId: string) => Promise<string>;
  loadSummary: (paymentId: string) => Promise<unknown>;
}): Promise<string> {
  const basketId = await operations.enrolBasket(isCombined);
  const paymentId = await operations.getPaymentId(basketId);
  await operations.loadSummary(paymentId);
  return paymentId;
}
